
import MenuComboActionTile from "../menu/menu-combo-action-tile.vue";
import ResponsiveDialog from "./responsive-dialog.vue";
import MenuNormalItemActionTile from "../menu/menu-normal-item-action-tile.vue";
export default {
  components: {
    ResponsiveDialog,
    MenuComboActionTile,
    MenuNormalItemActionTile
  },
  props: {
    dialog: false,
    item: {
      defaault: () => {},
      type: Object
    }
  }
};
